// service.js
import DataService from "../dataService";
import api from "../api";

const getTechnicalOfficer = async () => {
    try {
        const response = await DataService.get(api.technicalOfficerApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching getPad';
    }
};
const getFarmers = async () => {
    try {
        const response = await DataService.get(api.farmersApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching farmers';
    }
};
const getFPOFPC = async () => {
    try {
        const response = await DataService.get(api.FPOFPCApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching FPOFPC';
    }
};
const getAgriBusinessPartner = async () => {
    try {
        const response = await DataService.get(api.agriBusinessPartnerApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching agriBusinessPartnerApi';
    }
};
const getMSME = async () => {
    try {
        const response = await DataService.get(api.MSMEApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching MSMEApi';
    }
};
const getStartup = async () => {
    try {
        const response = await DataService.get(api.startupApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching StartupApi';
    }
};

export {
    getStartup,
    getMSME,
    getAgriBusinessPartner,
    getFPOFPC,
    getFarmers,
    getTechnicalOfficer
}